import { filledArrowDownDataUri } from 'components/Icon/filledArrowDownDataUri';
import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding-top: 12px;
	border-top: 1px solid ${({ theme }) => theme.gray[200]};
`;

export const Header = styled.div`
	font-size: 12px;
	font-weight: 500;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: ${({ theme }) => theme.gray[700]};
`;

export const Row = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
`;

export const SelectWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	flex: 1;
	min-width: 0;
`;

export const Select = styled.select`
	flex: 1;
	min-width: 0;
	appearance: none;
	padding: 8px 32px 8px 12px;
	border: 1px solid ${({ theme }) => theme.gray[400]};
	border-radius: 6px;
	background-color: ${({ theme }) => theme.gray[100]};
	color: ${({ theme }) => theme.gray[1000]};
	font-size: 13px;
	background-image: url('data:image/svg+xml;utf8,${({ theme }) =>
		encodeURIComponent(filledArrowDownDataUri(theme.gray[1000]))}');
	background-repeat: no-repeat;
	background-position: top 50% right 12px;
	background-size: 12px auto;

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.blue[500]};
	}

	&:disabled {
		opacity: 0.6;
	}
`;

export const StaticLabel = styled.div`
	flex: 1;
	padding: 8px 12px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 6px;
	background-color: ${({ theme }) => theme.gray[100]};
	color: ${({ theme }) => theme.gray[1000]};
	font-size: 13px;
`;

export const CopyButton = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 8px 14px;
	border: 1px solid ${({ theme }) => theme.blue[700]};
	border-radius: 20px;
	background-color: ${({ theme }) => theme.blue[500]};
	color: #ffffff;
	font-size: 12px;
	font-weight: 500;
	white-space: nowrap;

	&:hover {
		background-color: ${({ theme }) => theme.blue[600]};
	}
`;
